import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import { CustomerData, CustomerWithAllocatedCarbonSavings } from "./types"

export const getCustomers = (apiClient: APIClient): Promise<CustomerData> =>
	apiClient.get("/customers").then(response => response.data)

export const getCustomersWithAllocatedCarbonSavings = (
	apiClient: APIClient,
): Promise<CustomerWithAllocatedCarbonSavings[]> =>
	apiClient
		.get("/customers/allocated-carbon-savings")
		.then(response => response.data)
